// extracted by mini-css-extract-plugin
export default {"wrapper":"_404_wrapper__Gx04v","title":"_404_title__6p+hD","message":"_404_message__q8pSc","button":"_404_button__9k2Bi"};